import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { block } from './block';
import { checkInDateRange } from './checkInDateRange';
import { countries } from './countries';
import { departureCity } from './departureCity';
import { directFlight } from './directFlight';
import { hotelCategories } from './hotelCategories';
import { hotels } from './hotels';
import { meals } from './meals';
import { nightRange } from './nightRange';
import { resorts } from './resorts';
import { touristGroup } from './touristGroup';

export const SEARCH_CRITERIA_QUERY_KEYS = [
  'fromCity',
  'toCountry',
  'toCity',
  'dateFrom',
  'dateTo',
  'daysFlexible',
  'nightFrom',
  'nightTo',
  'adults',
  'kids',
  'infants',
  'ages',
  'rooms',
  'hotelClass',
  'meal',
  'hotels',
  'directFlight',
  'block',
] as const;

export const LEGACY_DROPPED_QUERY_KEYS = ['toCountries', 'priceFrom', 'priceTo', 'warranted', 'mirCashback'] as const;

export function fromSearchCriteriaQuery(query: QueryObject): Partial<SearchCriteriaParams> | null {
  const params: Partial<SearchCriteriaParams> = {
    ...departureCity(query),
    ...countries(query),
    ...resorts(query),
    ...checkInDateRange(query),
    ...nightRange(query),
    ...touristGroup(query),
    ...hotelCategories(query),
    ...meals(query),
    ...hotels(query),
    ...directFlight(query),
    ...block(query),
  };

  return Object.keys(params).length ? params : null;
}
